import { ErrorOption } from 'react-hook-form';

import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { FontScaleName, getFontScale } from 'themes/mixins/getFontScale';

import { Button } from 'components/Button';
import { FlagName } from 'components/FlagLabel';

import { InputMotives, pickMotive } from './inputMotives';

export type StyledInputProps = {
  error?: ErrorOption;
  scale?: FontScaleName;
  motive?: InputMotives;
  withNoLabel?: boolean;
  flag?: FlagName;
};

export type StyledFlagWrapperProps = Pick<StyledInputProps, 'withNoLabel'>;

const Wrapper = styled.div<StyledInputProps>`
  display: flex;
  flex-direction: column;

  ${({ motive }) => motive && pickMotive(motive)};

  ${({ error }) =>
    error
      ? css`
          input {
            border-color: ${pickColor('red')};
          }
        `
      : null}
`;

const InputWrapper = styled.div<StyledFlagWrapperProps>`
  position: relative;

  width: 100%;
`;

const FlagWrapper = styled.div<StyledFlagWrapperProps>``;

const SInput = styled.input<StyledInputProps>`
  display: block;

  min-height: 2rem;
  /* max-height: 3.3rem; */
  width: 100%;
  padding: 0.6rem 1.2rem;
  margin-left: ${({ withNoLabel }) => (withNoLabel ? '12rem' : '0')};

  color: ${pickColor('black')};
  background-color: ${pickColor('white')};
  border: 0.1rem solid ${pickColor('black')};

  font-size: 1.2rem !important;

  ${getFontScale};

  ${({ flag }) =>
    flag
      ? css`
          padding-left: 5.6rem;
          margin-left: 0;
        `
      : null}

  &:disabled {
    background-color: ${pickColor('graySecondary')};
    border-color: ${pickColor('graySecondary')};
  }
`;

const PasswordButton = styled(Button)`
  position: absolute;

  top: 50%;

  right: 1.7rem;

  transform: translateY(-50%);
`;

export { FlagWrapper, InputWrapper, PasswordButton, SInput, Wrapper };
